export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_POLICY_MESSAGE =
  'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre';

export const PASSWORD_RULES = [
  {
    id: 'length',
    label: 'Au moins 8 caractères',
    test: (password: string) => password.length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: 'uppercase',
    label: 'Une lettre majuscule',
    test: (password: string) => /[A-Z]/.test(password),
  },
  {
    id: 'lowercase',
    label: 'Une lettre minuscule',
    test: (password: string) => /[a-z]/.test(password),
  },
  {
    id: 'digit',
    label: 'Un chiffre',
    test: (password: string) => /\d/.test(password),
  },
] as const;

export function isPasswordValid(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}

export function passwordsMatch(password: string, confirmPassword: string): boolean {
  return password.length > 0 && password === confirmPassword;
}
